import React from "react";

function TpvAdd()  {
return (
    <div>
        <h1>
        TPV Screen
        </h1>
    </div>
)
}

export default TpvAdd;